import { rei } from "@/services/api"

class PreRegistroService {
  static getRegistro (params) {
    return rei.get(`pre-registro`, { params }).then(res => res.data)
  }

  static getPadrinhos (params) {
    return rei.get(`pre-registro-padrinho`, { params }).then(res => res.data)
  }

  static importRegistro (params) {
    return rei.post(`pre-registro`, params).then(res => res.data)
  }
}

export default PreRegistroService
